import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, AsyncSubject, of } from 'rxjs';
import { Router } from '@angular/router';

import { CurrentUser } from './../dataTypes/CurrentUser';
import * as _ from 'lodash';
import { AuthService } from './AuthService';
import { ConfigService } from '../shared/services/config.service';


@Injectable()
export class AuthServiceGuest extends AuthService {

  public url = '';

  constructor(public _ConfigService: ConfigService, public http: HttpClient, public _router: Router) {
    super(http, _router);

    this.url = _ConfigService._serverUrl + '/token';
  }

  getUserPermissions(cb?) {
    const self = this;
    self.userPermissions.next([]);
    self.userPermissions.complete();
    if (cb) {
      cb();
    }
  }

  getUserInfo(): CurrentUser {

    const username = localStorage.getItem('userName');
    const userFirstName = localStorage.getItem('userFirstName');

    const companyName = localStorage.getItem('companyName');
    const companyCode = localStorage.getItem('companyCode');

    const allowDelete = (localStorage.getItem('allowDelete') === 'true');
    const visibiltyPermissions = parseInt(localStorage.getItem('visibiltyPermissions'), 10);
    const AllowEditGuestEndDate = (localStorage.getItem('AllowEditGuestEndDate') === 'true');
    const incrementEndDateByOneDay = (localStorage.getItem('incrementEndDateByOneDay') === 'true');
    const guestValidateIdentityNumber = (localStorage.getItem('guestValidateIdentityNumber') === 'true');

    const permission = parseInt(localStorage.getItem('permission'), 10);

    const user = new CurrentUser(
      username,
      userFirstName,
      [],
      companyName,
      companyCode,
      allowDelete,
      visibiltyPermissions,
      AllowEditGuestEndDate,
      incrementEndDateByOneDay,
      guestValidateIdentityNumber,

      permission);
   

    return user;
  }

  notifyUserLoggedIn(user: CurrentUser) {

    const self = this;
    self.userModel.next(user);

   
  }

  isLoggedInGuests() {
    var expiredToken =  localStorage.getItem('expire');

    if (!expiredToken) {
      return false;
    }

    if (new Date(expiredToken) < new Date()) {
      return false;
    }

    var token = localStorage.getItem('auth_token');
    if (token) return true;

    return false;
  }

  getAuthTokenGuests() {

    if (this.isLoggedInGuests()) {
      return localStorage.getItem('auth_token');
    }
    else return '';
  }

  login(username, password): Observable<object> {
   
    this.started = false;
    const self = this;

    var success = false;

    this.url = self._ConfigService._serverUrl + '/token';

    const data = { grant_type: 'password', username: username, password: password };
    const str = Object.keys(data).map(function (key) {
      return key + '=' + data[key];
    }).join('&');
   

    let reqHeader = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });


    return self.http.post(self.url, str, { headers: reqHeader });


     
  }

  redirectAfterLogin() {
    this._router.navigate(['']);
  }

  /*
   *  let res = response.json();



        let success: boolean = false;
        if (!res.error) {

          const timestampLogin = new Date().getTime();
          localStorage.setItem('auth_token', res.access_token);
          localStorage.setItem('refresh_token', res.refresh_token);
          localStorage.setItem('timestampLogin', timestampLogin + '');
          localStorage.setItem('expire', res.expires_in + '');
          self.authToken.next(res.access_token);
          self.refreshToken = res.refresh_token;
          self.expire = res.expire;
          self.timestampLogin = timestampLogin;

          localStorage.setItem('userName', username);
          localStorage.setItem('companyName', res.companyName);
          localStorage.setItem('companyCode', res.companyCode + '');

          localStorage.setItem('allowDelete', res.allowDelete);
          localStorage.setItem('visibiltyPermissions', res.visibiltyPermissions);
          localStorage.setItem('AllowEditGuestEndDate', res.AllowEditGuestEndDate);
          localStorage.setItem('incrementEndDateByOneDay', res.incrementEndDateByOneDay);
          localStorage.setItem('guestValidateIdentityNumber', res.guestValidateIdentityNumber);
          const user = new CurrentUser(
            username,
            username,
            [],
            res.companyName,
            res.companyCode,
            res.allowDelete,
            res.visibiltyPermissions,
            res.AllowEditGuestEndDate,
            res.incrementEndDateByOneDay,
            res.guestValidateIdentityNumber);
       
          self.userModel.next(user);

          self.loggedIn = true;
          success = true;
        }
        return of(success);


let errMsg: string;
          if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
          } else {
            errMsg = error.message ? error.message : error.toString();
          }
          console.error(errMsg);
          return Observable.throw(errMsg);

*/
}


